import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './text-box-group.scss';
import { getDigitsOnly, getNumberWithDot } from '../../helpers/utils';
import Tooltip from '../tooltip/tooltip';
import { InfoIcon } from '../icons/icons';

const TextBoxGroup = forwardRef(
  (
    {
      id,
      label,
      errorMessage,
      required,
      message,
      className,
      bach,
      placement,
      type,
      infoIconSize,
      infoIconColor,
      extraplaceholder,
      decimalLimit,
      onKeyUp,
      ...otherProps
    },
    ref
  ) => {
    // const textBox = useRef(null);
    return (
      <div
        className={`text-box-group-container ${className} ${
          errorMessage ? 'error' : ''
        }`}
      >
        {label && (
          <label htmlFor={id}>
            {label}
            {required && <span className="required">*</span>}
          </label>
        )}
        <div className={`text-box-group-wrapper ${placement}`}>
          <input
            id={id}
            ref={ref}
            onKeyDown={(e) => {
              if (type === 'number') {
                if (id === 'quantity' && !decimalLimit) {
                  getDigitsOnly(e);
                } else {
                  getNumberWithDot({ e, decimalLimit: decimalLimit || 2 });
                }
              }
            }}
            onKeyUp={onKeyUp}
            {...otherProps}
          />
          {extraplaceholder !== '' && (
            <span className="extra-placeholder">{extraplaceholder}</span>
          )}
          {bach && <span className="bach">{bach}</span>}
          {errorMessage && (
            <span className="bach">
              <Tooltip content={errorMessage} direction="right">
                <InfoIcon
                  color={infoIconColor}
                  width={infoIconSize}
                  height={infoIconSize}
                />
              </Tooltip>
            </span>
          )}
        </div>

        {message !== '' && <p className="message">{message}</p>}
        {/* {errorMessage !== '' && <p className="error-message">{errorMessage}</p>} */}
      </div>
    );
  }
);
TextBoxGroup.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  message: PropTypes.string,
  mBottom: PropTypes.string,
  size: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  placement: PropTypes.string,
  bach: PropTypes.string,
  type: PropTypes.string,
  infoIconSize: PropTypes.string,
  infoIconColor: PropTypes.string,
  extraplaceholder: PropTypes.string,
  decimalLimit: PropTypes.number,
  onKeyUp: PropTypes.func,
};
TextBoxGroup.defaultProps = {
  label: '',
  id: '',
  errorMessage: '',
  required: false,
  message: '',
  mBottom: '',
  size: '',
  width: '',
  className: '',
  placement: '',
  bach: '',
  type: 'text',
  infoIconSize: '0.833vw',
  infoIconColor: '#da0101',
  extraplaceholder: '',
  decimalLimit: 0,
  onKeyUp: () => {},
};
export default TextBoxGroup;
